import { getfreshToken } from '@/api/user'
import axios from 'axios'
import qs from 'qs'
import { getToken, setToken, types } from '../Token'
import { responseHandle } from './handle/responseHandle'

import { Toast } from 'vant'

import store from '@/store'

// Toast.allowMultiple();

let loadingCount = 0
let loading = ''

function toast() {
	if (loadingCount !== 0) {
		loading = Toast.loading({
			forbidClick: true,
			duration: 0
		})
	} else {
		loading.clear()
	}
}

const PlatForm = process.env.VUE_APP_PLATFORM //商城项目名称  GZBANK KWTO

const service = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL,
	timeout: 7500
})

window.isRefreshing = false

service.interceptors.request.use(
	(config) => {
		if (getToken(types.Token)) {
			const refreshTime = parseInt(new Date().getTime() / 1000)
			if (refreshTime - getToken(types.Expiresat) < 0) {
				config.headers['Authorization'] = `Bearer ${getToken(types.Token)}`
			} else {
				if (refreshTime - getToken(types.Refresh_token_expiresat) < 0) {
					if (!window.isRefreshing) {
						window.isRefreshing = true
						let refresh_token = getToken(types.Refresh_token)
						getfreshToken({ token: refresh_token }).then((res) => {
							setToken({
								Token: res.data.data.token,
								Refresh_token: res.data.data.refresh_token,
								Refresh_token_expiresat: res.data.data.refresh_token_expiresat,
								Expiresat: res.data.data.expiresat
							})
							window.isRefreshing = true
						})
					} else {
						window.isRefreshing = true
					}
				} else {
					store.dispatch('user/loginOut')
				}
			}
		}

		loadingCount++
		toast()
		config.url = config.url + `?platform=${PlatForm}`
		if (config.data) config.data = qs.stringify(config.data)

		return config
	},
	(error) => {
		loadingCount = 0
		toast()
		console.log(error)
		return Promise.reject(error)
	}
)

function errorHandle(error) {
	if (error.message.includes('timeout')) {
		loadingCount = 0
		toast()
		Toast('当前网络异常, 请稍后再试')
	}
	return Promise.resolve(error)
}

service.interceptors.response.use((response) => {
	loadingCount--
	toast()
	if (response.data.code > 0) {
		responseHandle(response.data)
		return Promise.reject()
	} else {
		if (response.headers.token) {
			const data = {
				Refresh_token: response.headers.refresh_token,
				Token: response.headers.token,
				Tefresh_token_expiresat: response.headers.refresh_token_expiresat,
				Expiresat: response.headers.expiresat
			}
			setToken(data)
		}
		if (!response.data.data.status) {
			Toast(response.data.data.message)
		}
		return Promise.resolve(response)
	}
}, errorHandle)

export default service
